import {Injectable, EventEmitter} from "@angular/core";

@Injectable()
export class SpinnerService{
    showSpinner = new EventEmitter<boolean>();

    show(): void {
        this.showSpinner.emit(true);
    }

    hide(): void {
        this.showSpinner.emit(false);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/spinner.service.ts